import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  HostListener,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-select-dimension-dropdown',
  templateUrl: './select-dimension-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SelectDimensionDropdown implements OnInit {
  @Input() disabled = false;
  @Output() selectedOptionChange = new EventEmitter<string>();

  selectedOption = 'device';
  isOpen = signal(false);

  optionList = [
    { value: 'device', viewValue: 'Edges' },
    { value: 'connection', viewValue: 'Links' },
  ];

  get selectedLabel(): string {
    return (
      this.optionList.find((o) => o.value === this.selectedOption)?.viewValue ??
      ''
    );
  }

  ngOnInit(): void {
    this.selectedOptionChange.emit(this.selectedOption);
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.disabled) this.isOpen.update((v) => !v);
  }

  select(value: string, event: MouseEvent): void {
    event.stopPropagation();
    this.selectedOption = value;
    this.isOpen.set(false);
    this.selectedOptionChange.emit(value);
  }

  @HostListener('document:click')
  close(): void {
    this.isOpen.set(false);
  }
}
